// Dynamic redirect URI configuration for multiple ports
const getRedirectUri = () => {
  const currentPort = window.location.port;
  const baseUrl = `${window.location.protocol}//${window.location.hostname}`;
  
  // Map different ports to standardized redirect URIs
  switch(currentPort) {
    case '3000': // Full Okta mode
      return `${baseUrl}:3000/login/callback`;
    case '3002': // Hybrid mode  
      return `${baseUrl}:3002/login/callback`;
    case '3004': // No-auth mode
      return `${baseUrl}:3004/login/callback`;
    default:
      // Fallback to current origin
      return window.location.origin + '/login/callback';
  }
};

// Runtime config injected by the Lyric backend into index.html (from
// lyric-secrets at request time). Preferred over the build-time env so a
// single static production bundle picks up this environment's Okta values.
const runtimeEnv = (typeof window !== 'undefined' && window.__LYRIC_ENV__) || {};

const oktaConfig = {
  clientId: runtimeEnv.REACT_APP_OKTA_CLIENT_ID || process.env.REACT_APP_OKTA_CLIENT_ID || '0oawvoqfcxnENEyAO697',
  issuer: runtimeEnv.REACT_APP_OKTA_ISSUER || process.env.REACT_APP_OKTA_ISSUER || 'https://internal.rapid.ai/oauth2/default',
  redirectUri: getRedirectUri(),
  postLogoutRedirectUri: window.location.origin,
  scopes: ['openid', 'profile', 'email', 'offline_access'], // Added offline_access for refresh tokens
  pkce: true,
  responseType: ['code'],
  responseMode: 'query', // Changed from 'fragment' to 'query' for better compatibility
  disableHttpsCheck: process.env.NODE_ENV === 'development',
  features: {
    registration: false
  },
  // Token manager configuration to handle refresh tokens properly
  tokenManager: {
    autoRenew: true,
    secure: process.env.NODE_ENV === 'production',
    storage: 'localStorage',
    expireEarlySeconds: 120 // Renew tokens 2 minutes before expiry
  },
  // Services configuration to enable refresh token service
  services: {
    autoRenew: true,
    autoRemove: true
  }
};

// Debug logging for redirect URI
console.log('🔍 Okta Configuration Debug:');
console.log(`   Current URL: ${window.location.href}`);
console.log(`   Port: ${window.location.port}`);
console.log(`   Redirect URI: ${oktaConfig.redirectUri}`);
console.log(`   Post Logout URI: ${oktaConfig.postLogoutRedirectUri}`);
console.log(`   Client ID: ${oktaConfig.clientId}`);
console.log(`   Issuer: ${oktaConfig.issuer}`);

export default oktaConfig;
